// extracted by mini-css-extract-plugin
module.exports = {"hop-Menu":"Menu_hop-Menu__YzGqs","hop-Menu__header":"Menu_hop-Menu__header__LTetN","hop-Menu__divider":"Menu_hop-Menu__divider__CTJ3F"};